import { render, staticRenderFns } from "./ReferLogin.vue?vue&type=template&id=3328e842&scoped=true&"
import script from "./ReferLogin.vue?vue&type=script&lang=js&"
export * from "./ReferLogin.vue?vue&type=script&lang=js&"
import style0 from "./ReferLogin.vue?vue&type=style&index=0&id=3328e842&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3328e842",
  null
  
)

export default component.exports